import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("ihd_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const p = window.location.pathname;
    if (err.response?.status === 401 && p.startsWith("/admin") && p !== "/admin/login") {
      localStorage.removeItem("ihd_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export const media = (u) => (u && u.startsWith("/api/") ? BACKEND + u : u || "");

export const lines = (s) => (s || "").split("\n").map((x) => x.trim()).filter(Boolean);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};

export const LISTING_ANCHORS = {
  cat1: "gate-fold",
  cat2: "double-page",
  cat3: "full-page",
  cat4: "half-page",
  cat5: "photo-listing",
  cat6: "normal-listing",
};
export const CAT_KEYS = Object.keys(LISTING_ANCHORS);
